export class ExternalConnection {
    static ReactNativeWebviewRedirect(action) {
        // if (typeof (window.ReactNativeWebView) !== 'undefined' && ('postMessage' in window.externReactNativeWebViewal)) {
            window.ReactNativeWebView.postMessage(action);
            console.log('Reactnative redirect action: '+ action);
        // }
    }
  }